import { observer, useViewModel } from '@descomplica/microfrontend-react';
import { format } from 'date-fns';
import { useEffect } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { StudentClassIdentifier } from '@/application/commons/enums/student-class.enum';
import Loading from '@/presentation/components/loading';
import PaywallComponent from '@/presentation/components/paywall/paywall';

import { paywallData } from './paywall.data';
import { PaywallViewModel } from './paywall.vm';

const Paywall: React.FC = () => {
  const vm = useViewModel(PaywallViewModel);
  const navigate = useNavigate();

  useEffect(() => {
    if (vm.shouldRedirectToLMS) {
      navigate('/library');
    }
  }, [vm.shouldRedirectToLMS, navigate]);

  if (vm.isLoading) {
    return <Loading />;
  }

  const { illustration, title, subtitle } = paywallData[vm.paywallType];
  let subtitleText;

  if (vm.paywallType === StudentClassIdentifier.CurrentStudentClassHasNotStarted) {
    const formattedStartDate = format(new Date(vm.studentClass?.startDate), 'dd/MM/yyyy');
    subtitleText = subtitle.replace('startDate', formattedStartDate);
  } else if (vm.paywallType === StudentClassIdentifier.CurrentStudentClassHasExpired) {
    const formattedEndDate = format(new Date(vm.studentClass?.endDate), 'dd/MM/yyyy');
    subtitleText = subtitle.replace('endDate', formattedEndDate);
  }

  return <PaywallComponent illustration={illustration} title={title} subtitleText={subtitleText} />;
};

export default observer(Paywall);
